// extracted by mini-css-extract-plugin
module.exports = {"mojoInfoHeader":"MojoInfoCard_mojoInfoHeader__c52tg","mojoInfoRow":"MojoInfoCard_mojoInfoRow__1uVIu","mojoInfoRowText":"MojoInfoCard_mojoInfoRowText__2L6ow"};